var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_2792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 1.95312V18.2031H14.0781V16.9531H5.32812V3.20312H11.5781V6.95312H15.3281V8.20312H16.5781V6.07812L16.3906 5.89062L12.6406 2.14062L12.4531 1.95312H4.07812ZM12.8281 4.07812L14.4531 5.70312H12.8281V4.07812ZM6.57812 8.20312V9.45312H14.0781V8.20312H6.57812ZM17.2031 9.45312V10.7031C16.1406 10.8906 15.3281 11.7656 15.3281 12.8906C15.3281 14.1406 16.2656 15.0781 17.5156 15.0781H18.1406C18.6406 15.0781 19.0781 15.5156 19.0781 16.0156C19.0781 16.5156 18.6406 16.9531 18.1406 16.9531H15.9531V18.2031H17.2031V19.4531H18.4531V18.2031C19.5156 18.0156 20.3281 17.1406 20.3281 16.0156C20.3281 14.7656 19.3906 13.8281 18.1406 13.8281H17.5156C17.0156 13.8281 16.5781 13.3906 16.5781 12.8906C16.5781 12.3906 17.0156 11.9531 17.5156 11.9531H19.7031V10.7031H18.4531V9.45312H17.2031ZM6.57812 11.3281V12.5781H10.9531V11.3281H6.57812ZM12.2031 11.3281V12.5781H14.0781V11.3281H12.2031ZM6.57812 13.8281V15.0781H10.9531V13.8281H6.57812ZM12.2031 13.8281V15.0781H14.0781V13.8281H12.2031Z",
    fill: "#9C4900",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_2792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.328125 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.63b127f390094165f959fec033477837.svg";
export { ForwardRef as ReactComponent };